const handleDeleteEquipmentModelsFail = {
  title: 'TIPO DE EQUIPAMENTO NÃO PODE SER DELETADO',
  message: 'Não pode ser deletado. Utilizado por',
  companies: 'Empresas',
  items: 'Itens',
  equipmentmodels: 'Tipos de Equipamentos',
  equipments: 'Equipamentos',
  inspections: 'Inspeções',
  itemverifications: 'Itens de Verificação',
  default: 'Coleção Genérica'
};

export default handleDeleteEquipmentModelsFail;
